import React, { useEffect } from "react";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import { MyUploadFile } from "../../molecules";
import { Gap, MyButton, MyInput } from "../../atoms";
import {
  deleteDocument,
  uploadDocument,
  downloadDocument,
} from "../../../config/Redux/Global/actions";
import { useDispatch, useSelector } from "react-redux";
import { getBase64 } from "../../../utils/constansColors";
import {
  downloadHistoryDocument,
  getExcoDocument,
  listHistoryDocument,
} from "../../../config/Redux/Global/actions";
import MyDialog from "../../molecules/Dialog";
import HelpIcon from "@mui/icons-material/Help";
import AlertMessage from "../../../components/molecules/AlertMessage";
import { useFormik } from "formik";
import * as yup from "yup";
import {
  getDetailExcoPusat,
  patchExcoDetail,
} from "../../../config/Redux/ExcoPusat/actions";
import { LOCAL_STORAGE_KEY } from "../../../config/API/config";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const validationSchema = yup.object().shape({
  nomer_sk_pengurus: yup
    .string()
    .required("Silahkan Masukan Nomor SK Pengurus Pleno"),
  tanggal_sk: yup
    .string()
    .required("Silahkan Masukan Tanggal SK Pengurus Pleno"),
});
const DokumenKepengurusan = ({
  dataDoc,
  nameExco,
  officeId,
  isLocked,
  tingkatExcoId,
  daerahId,
}) => {
  // console.log({ dataDoc });
  let exco_pusat = dataDoc?.filter(
    (item) =>
      item.kategori_dokumen.id !== 8 &&
      item.kategori_dokumen.id !== 2 &&
      item.kategori_dokumen.id !== 9 &&
      item.kategori_dokumen.id !== 10 &&
      item.kategori_dokumen.id !== 11 &&
      item.kategori_dokumen.id !== 12,
  );
  // console.log(dataDoc)
  let exco_provinsi = dataDoc?.filter(
    (item) =>
      item.kategori_dokumen.id === 8 ||
      item.kategori_dokumen.id === 1 ||
      item.kategori_dokumen.id === 16,
  );
  let exco_kabkot = dataDoc?.filter(
    (item) =>
      item.kategori_dokumen.id === 8 ||
      item.kategori_dokumen.id === 1 ||
      item.kategori_dokumen.id === 16,
  );
  let exco_kecamatan = dataDoc?.filter(
    (item) => item.kategori_dokumen.id === 1 || item.kategori_dokumen.id === 8,
  );
  let resultArr = [];
  // console.log({ resultArr2: resultArr });
  if (nameExco === "EXCO Pusat") {
    resultArr = exco_pusat;
  }
  if (nameExco === "EXCO Provinsi") {
    resultArr = exco_provinsi;
  }
  if (nameExco === "EXCO Kabupaten/Kota") {
    resultArr = exco_kabkot;
  }
  if (nameExco === "EXCO Kecamatan") {
    resultArr = exco_kecamatan;
  }
  if (nameExco === "EXCO Kelurahan/Desa") {
    resultArr = exco_kecamatan;
  }
  if (nameExco?.includes("EXCO RT")) {
    resultArr = dataDoc?.filter((item) => item.kategori_dokumen.id === 1);
  }
  if (nameExco === "Komisaris Basis" || nameExco === "Komisaris RT/RW") {
    resultArr = dataDoc?.filter((item) => item.kategori_dokumen.id === 1);
  }
  const dispatch = useDispatch();
  const [openDelete, setOpenDelete] = React.useState(false);

  const [openView, setOpenView] = React.useState(false);
  const [fileNameMenkumham, setFileNameMenkumham] = React.useState(null);
  const [fileNameAktaNotaris, setFileNameAktaNotaris] = React.useState(null);
  const [fileNamePengurus, setFileNamePengurus] = React.useState(null);
  const [fileNameMenkumhamAD, setFileNameMenkumhamAD] = React.useState(null);
  const [fileNameKeBangSol, setFileNameKeBangSol] = React.useState(null);

  const [fileNameBadanHukum, setFileNameBadanHukum] = React.useState(null);
  const [fileNameAktaNotarisPendirian, setFileNameAktaNotarisPendirian] =
    React.useState(null);
  const [fileNameLambangPartai, setFileNameLambangPartai] =
    React.useState(null);
  const [fileNameLambangPartaiMenkumham, setFileNameLambangPartaiMenkumham] =
    React.useState(null);
  const [fileNamePernyataanModelF, setFileNamePernyataanModelF] =
    React.useState(null);
  const [fileNameSKLampiran, setFileNameSKLampiran] = React.useState(null);

  // alert message
  const [openDialogAlert, setOpenDialogAlert] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [status, setStatus] = React.useState(null);

  // delete doc
  const [categoryDoc, setCategoryDoc] = React.useState(null);
  const [idDocument, setIdDocument] = React.useState(null);
  const [docName, setDocName] = React.useState(null);
  const [documentView, setDocumentView] = React.useState(null);

  // opendialog sk pengurus pleno
  const [openDialogSKPengurus, setOpenDialogSKPengurus] = React.useState(false);

  // loading
  const [loading, setLoading] = React.useState(false);
  const [loadingHistoryDownloadId, setLoadingHistoryDownloadId] =
    React.useState(null);

  const [openHistory, setOpenHistory] = React.useState(false);
  const [dataHistoryDokumen, setDataHistoryDokumen] = React.useState(null);
  const handleCloseDialogHistory = () => {
    setOpenHistory(false);
  };

  // selector
  const dataDetailExcoPusat = useSelector(
    (state) => state.excopusat.dataDetailExcoPusat,
  );
  let dataDetail = dataDetailExcoPusat && dataDetailExcoPusat.data;
  // console.log(`dokumenkepengurusan`, dataDetail);

  const handleCloseDialogDelete = () => {
    setOpenDelete(false);
  };
  const handleCloseDialogView = () => {
    setOpenView(false);
  };
  const handleCloseDialogSKPengurus = () => {
    setOpenDialogSKPengurus(false);
  };

  const base64ToBlob = (base64, type = "application/octet-stream") => {
    const binStr = atob(base64.split(",")[1]);
    const len = binStr.length;
    const arr = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      arr[i] = binStr.charCodeAt(i);
    }
    return new Blob([arr], { type: type });
  };

  const handleselectedFiles = async (event, param) => {
    let base64 = await getBase64(event);

    if (param === 1) {
      let payload = {
        id_kantor_exco: officeId,
        id_kategori_dokumen: "1",
        file_name: event?.name?.slice(0, -4),
        dokumen: `${base64}`,
      };
      setLoading(true);
      let resp = await dispatch(uploadDocument(payload));
      if (resp.type === "UPLOAD_DOCUMENT_SUCCESS") {
        await dispatch(getExcoDocument(officeId));
        setFileNamePengurus(event.name);
        setLoading(false);
        setMessage(
          <div align="center">
            <p>SK Pengurus Pleno</p>
            {resp.payload.message}
          </div>,
        );
        setOpenDialogAlert(true);
        setStatus("");
      } else {
        setLoading(false);
        setMessage(resp.payload.data.message);
        setOpenDialogAlert(true);
        setStatus("error");
      }
    }
    // SK Menkumham Pengurus =2
    if (param === 2) {
      let payload = {
        id_kantor_exco: officeId,
        id_kategori_dokumen: "2",
        file_name: event?.name?.slice(0, -4),
        dokumen: `${base64}`,
      };
      setLoading(true);
      let resp = await dispatch(uploadDocument(payload));
      if (resp.type === "UPLOAD_DOCUMENT_SUCCESS") {
        setFileNameMenkumham(event.name);
        await dispatch(getExcoDocument(officeId));
        setLoading(false);
        setMessage(
          <div align="center">
            <p>SK Menkumham Pengurus</p>
            {resp.payload.message}
          </div>,
        );
        setOpenDialogAlert(true);
        setStatus("");
      } else {
        setLoading(false);
        setMessage(resp.payload.data.message);
        setOpenDialogAlert(true);
        setStatus("error");
      }
    }
    // SK Kemenkumham AD/ART = 9
    if (param === 9) {
      let payload = {
        id_kantor_exco: officeId,
        id_kategori_dokumen: "9",
        file_name: event?.name?.slice(0, -4),
        dokumen: `${base64}`,
      };

      setLoading(true);
      let resp = await dispatch(uploadDocument(payload));
      if (resp.type === "UPLOAD_DOCUMENT_SUCCESS") {
        setFileNameMenkumhamAD(event.name);
        await dispatch(getExcoDocument(officeId));
        setLoading(false);
        setMessage(
          <div align="center">
            <p>SK Kemenkumham AD/ART</p>
            {resp.payload.message}
          </div>,
        );
        setOpenDialogAlert(true);
        setStatus("");
      } else {
        setLoading(false);
        setMessage(resp.payload.data.message);
        setOpenDialogAlert(true);
        setStatus("error");
      }
    }
    // Akta Notaris AD/ART = 7
    if (param === 7) {
      let payload = {
        id_kantor_exco: officeId,
        id_kategori_dokumen: "7",
        file_name: event?.name?.slice(0, -4),
        dokumen: `${base64}`,
      };
      setLoading(true);
      let resp = await dispatch(uploadDocument(payload));
      if (resp.type === "UPLOAD_DOCUMENT_SUCCESS") {
        setFileNameAktaNotaris(event.name);
        await dispatch(getExcoDocument(officeId));
        setLoading(false);
        setMessage(
          <div align="center">
            <p> Akta Notaris AD/ART</p>
            {resp.payload.message}
          </div>,
        );
        setOpenDialogAlert(true);
        setStatus("");
      } else {
        setLoading(false);
        setMessage(resp.payload.data.message);
        setOpenDialogAlert(true);
        setStatus("error");
      }
    }
    // Akta SK Kesatuan Bangsa Politik = 8
    if (param === 8) {
      let payload = {
        id_kantor_exco: officeId,
        id_kategori_dokumen: "8",
        file_name: event?.name?.slice(0, -4),
        dokumen: `${base64}`,
      };

      setLoading(true);
      let resp = await dispatch(uploadDocument(payload));
      if (resp.type === "UPLOAD_DOCUMENT_SUCCESS") {
        setFileNameKeBangSol(event.name);
        await dispatch(getExcoDocument(officeId));
        setLoading(false);
        setMessage(
          <div align="center">
            <p>Akta SK Kesatuan Bangsa Politik</p>
            {resp.payload.message}
          </div>,
        );
        setOpenDialogAlert(true);
        setStatus("");
      } else {
        setLoading(false);
        setMessage(resp.payload.data.message);
        setOpenDialogAlert(true);
        setStatus("error");
      }
    }

    // Akta dokiumen bada hukum = 10
    if (param === 10) {
      let payload = {
        id_kantor_exco: officeId,
        id_kategori_dokumen: "10",
        file_name: event?.name?.slice(0, -4),
        dokumen: `${base64}`,
      };

      setLoading(true);
      let resp = await dispatch(uploadDocument(payload));
      if (resp.type === "UPLOAD_DOCUMENT_SUCCESS") {
        setFileNameBadanHukum(event.name);
        await dispatch(getExcoDocument(officeId));
        setLoading(false);
        setMessage(
          <div align="center">
            <p>Dokumen Badan Hukum Partai Buruh</p>
            {resp.payload.message}
          </div>,
        );
        setOpenDialogAlert(true);
        setStatus("");
      } else {
        setLoading(false);
        setMessage(resp.payload.data.message);
        setOpenDialogAlert(true);
        setStatus("error");
      }
    }

    // Akta notaris pendirian partai buruh = 11
    if (param === 11) {
      let payload = {
        id_kantor_exco: officeId,
        id_kategori_dokumen: "11",
        file_name: event?.name?.slice(0, -4),
        dokumen: `${base64}`,
      };

      setLoading(true);
      let resp = await dispatch(uploadDocument(payload));
      if (resp.type === "UPLOAD_DOCUMENT_SUCCESS") {
        setFileNameAktaNotarisPendirian(event.name);
        await dispatch(getExcoDocument(officeId));
        setLoading(false);
        setMessage(
          <div align="center">
            <p>Akta Notaris Pendirian Partai Buruh</p>
            {resp.payload.message}
          </div>,
        );
        setOpenDialogAlert(true);
        setStatus("");
      } else {
        setLoading(false);
        setMessage(resp.payload.data.message);
        setOpenDialogAlert(true);
        setStatus("error");
      }
    }

    // Lambang Partai Buruh = 12
    if (param === 12) {
      let payload = {
        id_kantor_exco: officeId,
        id_kategori_dokumen: "12",
        file_name: event?.name?.slice(0, -4),
        dokumen: `${base64}`,
      };

      setLoading(true);
      let resp = await dispatch(uploadDocument(payload));
      if (resp.type === "UPLOAD_DOCUMENT_SUCCESS") {
        setFileNameLambangPartai(event.name);
        await dispatch(getExcoDocument(officeId));
        setLoading(false);
        setMessage(
          <div align="center">
            <p>Lambang Partai Buruh</p>
            {resp.payload.message}
          </div>,
        );
        setOpenDialogAlert(true);
        setStatus("");
      } else {
        setLoading(false);
        setMessage(resp.payload.data.message);
        setOpenDialogAlert(true);
        setStatus("error");
      }
    }

    // Lambang Partai Buruh Menkumham = 13
    if (param === 13) {
      let payload = {
        id_kantor_exco: officeId,
        id_kategori_dokumen: "13",
        file_name: event?.name?.slice(0, -4),
        dokumen: `${base64}`,
      };

      setLoading(true);
      let resp = await dispatch(uploadDocument(payload));
      if (resp.type === "UPLOAD_DOCUMENT_SUCCESS") {
        setFileNameLambangPartaiMenkumham(event.name);
        await dispatch(getExcoDocument(officeId));
        setLoading(false);
        setMessage(
          <div align="center">
            <p>Surat Menkumham Lambang Partai Buruh</p>
            {resp.payload.message}
          </div>,
        );
        setOpenDialogAlert(true);
        setStatus("");
      } else {
        setLoading(false);
        setMessage(resp.payload.data.message);
        setOpenDialogAlert(true);
        setStatus("error");
      }
    }

    // Lambang Partai Buruh Menkumham = 14
    if (param === 14) {
      let payload = {
        id_kantor_exco: officeId,
        id_kategori_dokumen: "14",
        file_name: event?.name?.slice(0, -4),
        dokumen: `${base64}`,
      };

      setLoading(true);
      let resp = await dispatch(uploadDocument(payload));
      if (resp.type === "UPLOAD_DOCUMENT_SUCCESS") {
        setFileNamePernyataanModelF(event.name);
        await dispatch(getExcoDocument(officeId));
        setLoading(false);
        setMessage(
          <div align="center">
            <p>Surat Pernyataan Model F</p>
            {resp.payload.message}
          </div>,
        );
        setOpenDialogAlert(true);
        setStatus("");
      } else {
        setLoading(false);
        setMessage(resp.payload.data.message);
        setOpenDialogAlert(true);
        setStatus("error");
      }
    }
    // SK Pengurus Lampiran = 16
    if (param === 16) {
      let payload = {
        id_kantor_exco: officeId,
        id_kategori_dokumen: "16",
        file_name: event?.name?.slice(0, -4),
        dokumen: `${base64}`,
      };

      setLoading(true);
      let resp = await dispatch(uploadDocument(payload));
      if (resp.type === "UPLOAD_DOCUMENT_SUCCESS") {
        setFileNameSKLampiran(event.name);
        await dispatch(getExcoDocument(officeId));
        setLoading(false);
        setMessage(
          <div align="center">
            <p>SK Pengurus Lampiran</p>
            {resp.payload.message}
          </div>,
        );
        setOpenDialogAlert(true);
        setStatus("");
      } else {
        setLoading(false);
        setMessage(resp.payload.data.message);
        setOpenDialogAlert(true);
        setStatus("error");
      }
    }
  };

  const handleOpenDelete = (categoryDoc, idDocument, docName) => {
    setCategoryDoc(categoryDoc);
    setIdDocument(idDocument);
    setDocName(docName);
    setOpenDelete(true);
  };

  const handleDeleteFile = async (param, id) => {
    // SK Pengurus = 1
    if (param === 1) {
      const resp = await dispatch(deleteDocument(id));
      if (resp.type === "DELETE_DOCUMENT_SUCCESS") {
        setFileNamePengurus(null);
        setOpenDelete(false);
      }
    }
    // SK Menkumham Pengurus =2
    if (param === 2) {
      const resp = await dispatch(deleteDocument(id));
      if (resp.type === "DELETE_DOCUMENT_SUCCESS") {
        setFileNameMenkumham(null);
        setOpenDelete(false);
      }
    }
    // SK Kemenkumham AD/ART = 9
    if (param === 9) {
      const resp = await dispatch(deleteDocument(id));
      if (resp.type === "DELETE_DOCUMENT_SUCCESS") {
        setFileNameMenkumhamAD(null);
        setOpenDelete(false);
      }
    }
    // Akta Notaris AD/ART = 7
    if (param === 7) {
      const resp = await dispatch(deleteDocument(id));
      if (resp.type === "DELETE_DOCUMENT_SUCCESS") {
        setFileNameAktaNotaris(null);
        setOpenDelete(false);
      }
    }
    // Akta SK Kesatuan Kebangsaaan Politik = 8
    if (param === 8) {
      const resp = await dispatch(deleteDocument(id));
      if (resp.type === "DELETE_DOCUMENT_SUCCESS") {
        setFileNameKeBangSol(null);
        setOpenDelete(false);
      }
    }
    // Badan Hukum = 10
    if (param === 10) {
      const resp = await dispatch(deleteDocument(id));
      if (resp.type === "DELETE_DOCUMENT_SUCCESS") {
        setFileNameBadanHukum(null);
        setOpenDelete(false);
      }
    }
    // akta notaris pendirian = 11
    if (param === 11) {
      const resp = await dispatch(deleteDocument(id));
      if (resp.type === "DELETE_DOCUMENT_SUCCESS") {
        setFileNameAktaNotarisPendirian(null);
        setOpenDelete(false);
      }
    }
    // Lambang Partai = 12
    if (param === 12) {
      const resp = await dispatch(deleteDocument(id));
      if (resp.type === "DELETE_DOCUMENT_SUCCESS") {
        setFileNameLambangPartai(null);
        setOpenDelete(false);
      }
    }
    // Lambang Partai menkumham = 13
    if (param === 13) {
      const resp = await dispatch(deleteDocument(id));
      if (resp.type === "DELETE_DOCUMENT_SUCCESS") {
        setFileNameLambangPartaiMenkumham(null);
        setOpenDelete(false);
      }
    }
    // surat penyataan model f = 14
    if (param === 14) {
      const resp = await dispatch(deleteDocument(id));
      if (resp.type === "DELETE_DOCUMENT_SUCCESS") {
        setFileNamePernyataanModelF(null);
        setOpenDelete(false);
      }
    }
    // SK Pengurus Lampiran = 16
    if (param === 16) {
      const resp = await dispatch(deleteDocument(id));
      if (resp.type === "DELETE_DOCUMENT_SUCCESS") {
        setFileNameSKLampiran(null);
        setOpenDelete(false);
      }
    }
  };

  // download file
  const handleDownloadDoc = async (param, id) => {
    // if(pa)
    const resp = await dispatch(downloadDocument(id));

    if (resp.type === "DOWNLOAD_SUCCESS") {
      let data = await resp.payload.dokumen;
      // let resultData = `data:application/pdf;base64,${data}`;
      let resultData = `${data}`;
      let a = document.createElement("a");
      a.href = resultData;
      a.download = resp.payload.file_name;
      a.click();
    }
    // // SK Pengurus = 1
    // if (param === 1) {
    //   const resp = await dispatch(downloadDocument(id));

    //   if (resp.type === "DOWNLOAD_SUCCESS") {
    //     let data = await resp.payload.dokumen;
    //     let resultData = `data:application/pdf;base64,${data}`;
    //     let a = document.createElement("a");
    //     a.href = resultData;
    //     a.download = resp.payload.file_name;
    //     a.click();
    //   }
    // }
    // // SK Menkumham Pengurus =2
    // if (param === 2) {
    //   const resp = await dispatch(downloadDocument(id));

    //   if (resp.type === "DOWNLOAD_SUCCESS") {
    //     let data = await resp.payload.dokumen;
    //     let resultData = `data:application/pdf;base64,${data}`;
    //     let a = document.createElement("a");
    //     a.href = resultData;
    //     a.download = resp.payload.file_name;
    //     a.click();
    //   }
    // }
    // // SK Kemenkumham AD/ART = 9
    // if (param === 9) {
    //   const resp = await dispatch(downloadDocument(id));

    //   if (resp.type === "DOWNLOAD_SUCCESS") {
    //     let data = await resp.payload.dokumen;
    //     let resultData = `data:application/pdf;base64,${data}`;
    //     let a = document.createElement("a");
    //     a.href = resultData;
    //     a.download = resp.payload.file_name;
    //     a.click();
    //   }
    // }
    // // Akta Notaris AD/ART = 7
    // if (param === 7) {
    //   const resp = await dispatch(downloadDocument(id));

    //   if (resp.type === "DOWNLOAD_SUCCESS") {
    //     let data = await resp.payload.dokumen;
    //     let resultData = `data:application/pdf;base64,${data}`;
    //     let a = document.createElement("a");
    //     a.href = resultData;
    //     a.download = resp.payload.file_name;
    //     a.click();
    //   }
    // }
    // // Akta kesatuan kebangsaan politik = 8
    // if (param === 8) {
    //   const resp = await dispatch(downloadDocument(id));

    //   if (resp.type === "DOWNLOAD_SUCCESS") {
    //     let data = await resp.payload.dokumen;
    //     let resultData = `data:application/pdf;base64,${data}`;
    //     let a = document.createElement("a");
    //     a.href = resultData;
    //     a.download = resp.payload.file_name;
    //     a.click();
    //   }
    // }
    // // badan hukum = 10
    // if (param === 10) {
    //   const resp = await dispatch(downloadDocument(id));

    //   if (resp.type === "DOWNLOAD_SUCCESS") {
    //     let data = await resp.payload.dokumen;
    //     let resultData = `data:application/pdf;base64,${data}`;
    //     let a = document.createElement("a");
    //     a.href = resultData;
    //     a.download = resp.payload.file_name;
    //     a.click();
    //   }
    // }
  };

  // handle view file
  const handleViewDoc = async (param, id) => {
    const resp = await dispatch(downloadDocument(id));

    if (resp.type === "DOWNLOAD_SUCCESS") {
      let data = await resp.payload.dokumen;
      let resultData = `${data}`;
      const blob = base64ToBlob(resultData, "application/pdf");
      const url = URL.createObjectURL(blob);
      setDocumentView(url);
      setOpenView(true);
    }
    // // SK Pengurus = 1
    // if (param === 1) {
    //   const resp = await dispatch(downloadDocument(id));

    //   if (resp.type === "DOWNLOAD_SUCCESS") {
    //     let data = await resp.payload.dokumen;
    //     let resultData = `${data}`;
    //     const blob = base64ToBlob(resultData, "application/pdf");
    //     const url = URL.createObjectURL(blob);
    //     setDocumentView(url);
    //     setOpenView(true);
    //   }
    // }
    // // SK Menkumham Pengurus =2
    // if (param === 2) {
    //   const resp = await dispatch(downloadDocument(id));

    //   if (resp.type === "DOWNLOAD_SUCCESS") {
    //     let data = await resp.payload.dokumen;
    //     let resultData = `${data}`;

    //     const blob = base64ToBlob(resultData, "application/pdf");
    //     const url = URL.createObjectURL(blob);
    //     setDocumentView(url);
    //     setOpenView(true);
    //     // setFileNameMenkumham(null);
    //     // setOpenDelete(false);
    //   }
    // }
    // // SK Kemenkumham AD/ART = 9
    // if (param === 9) {
    //   const resp = await dispatch(downloadDocument(id));
    //   if (resp.type === "DOWNLOAD_SUCCESS") {
    //     let data = await resp.payload.dokumen;
    //     let resultData = `${data}`;
    //     const blob = base64ToBlob(resultData, "application/pdf");
    //     const url = URL.createObjectURL(blob);
    //     setDocumentView(url);
    //     setOpenView(true);
    //     // setFileNameMenkumhamAD(null);
    //     // setOpenDelete(false);
    //   }
    // }
    // // Akta Notaris AD/ART = 7
    // if (param === 7) {
    //   const resp = await dispatch(downloadDocument(id));
    //   if (resp.type === "DOWNLOAD_SUCCESS") {
    //     let data = await resp.payload.dokumen;
    //     let resultData = `${data}`;
    //     const blob = base64ToBlob(resultData, "application/pdf");
    //     const url = URL.createObjectURL(blob);
    //     setDocumentView(url);
    //     setOpenView(true);
    //     // setFileNameAktaNotaris(null);
    //     // setOpenDelete(false);
    //   }
    // }
    // // Akta SK Kebangsaan Kesatuan Politik = 8
    // if (param === 8) {
    //   const resp = await dispatch(downloadDocument(id));
    //   if (resp.type === "DOWNLOAD_SUCCESS") {
    //     let data = await resp.payload.dokumen;
    //     let resultData = `${data}`;
    //     const blob = base64ToBlob(resultData, "application/pdf");
    //     const url = URL.createObjectURL(blob);
    //     setDocumentView(url);
    //     setOpenView(true);
    //     // setFileNameAktaNotaris(null);
    //     // setOpenDelete(false);
    //   }
    // }
  };

  // handleopendialog sk pengurus
  const handleOpenSKPengurus = () => {
    setOpenDialogSKPengurus(true);
  };

  const formik = useFormik({
    initialValues: {
      nomer_sk_pengurus: dataDetail?.nomer_sk_pengurus,
      tanggal_sk: dataDetail?.tanggal_sk
        ? dataDetail.tanggal_sk.split("T")[0]
        : "",
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      // console.log(`onSubmit`, values);
      let payload = {
        nomer_sk_pengurus: values.nomer_sk_pengurus,
        tanggal_sk: values.tanggal_sk,
      };
      // console.log(`payload`, payload);
      // console.log(`payload`, payload);
      const resp = await dispatch(patchExcoDetail(officeId, payload));
      // console.log(`resp ubah data`, resp);
      if (resp.type === "PATCH_EXCO_PUSAT_SUCCESS") {
        // setLoading(false);
        handleCloseDialogSKPengurus();
        await dispatch(getDetailExcoPusat(tingkatExcoId, daerahId));
        setMessage(resp.payload.message);
        setOpenDialogAlert(true);
        setStatus("");
      } else {
        setMessage(resp.payload.data.message);
        setOpenDialogAlert(true);
        setStatus("error");
      }
    },
  });
  useEffect(() => {
    resultArr &&
      resultArr.map((item) => {
        let fileNameSKPengurus = "";
        let fileNameMenkumham = "";
        let fileNameMenkumhamAd = "";
        let fileNameAktaNotaris = "";
        let fileNameKeBangSol = "";

        let fileNameBadanHukum = "";
        let fileNameAktaNotarisPendirian = "";
        let fileNameLambangPartai = "";
        let fileNameLambangPartaiMenkumham = "";
        let fileNamePernyataanModelF = "";

        if (item.kategori_dokumen.id === 1) {
          fileNameSKPengurus = item.nama_dokumen;
          setFileNamePengurus(fileNameSKPengurus);
        }
        if (item.kategori_dokumen.id === 2) {
          fileNameMenkumham = item.nama_dokumen;
          setFileNameMenkumham(fileNameMenkumham);
        }
        if (item.kategori_dokumen.id === 9) {
          fileNameMenkumhamAd = item.nama_dokumen;
          setFileNameMenkumhamAD(fileNameMenkumhamAd);
        }
        if (item.kategori_dokumen.id === 7) {
          fileNameAktaNotaris = item.nama_dokumen;
          setFileNameAktaNotaris(fileNameAktaNotaris);
        }
        if (item.kategori_dokumen.id === 8) {
          fileNameKeBangSol = item.nama_dokumen;
          setFileNameKeBangSol(fileNameKeBangSol);
        }
        if (item.kategori_dokumen.id === 10) {
          fileNameBadanHukum = item.nama_dokumen;
          setFileNameBadanHukum(fileNameBadanHukum);
        }
        if (item.kategori_dokumen.id === 11) {
          fileNameAktaNotarisPendirian = item.nama_dokumen;
          setFileNameAktaNotarisPendirian(fileNameAktaNotarisPendirian);
        }
        if (item.kategori_dokumen.id === 12) {
          fileNameLambangPartai = item.nama_dokumen;
          setFileNameLambangPartai(fileNameLambangPartai);
        }
        if (item.kategori_dokumen.id === 13) {
          fileNameLambangPartaiMenkumham = item.nama_dokumen;
          setFileNameLambangPartaiMenkumham(fileNameLambangPartaiMenkumham);
        }
        if (item.kategori_dokumen.id === 14) {
          fileNamePernyataanModelF = item.nama_dokumen;
          setFileNamePernyataanModelF(fileNamePernyataanModelF);
        }
        if (item.kategori_dokumen.id === 16) {
          setFileNameSKLampiran(item.nama_dokumen);
        }
        return null;
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataDoc]);

  useEffect(() => {
    const safeTingkat =
      tingkatExcoId || (nameExco === "EXCO Pusat" ? "1" : undefined);
    if (safeTingkat) {
      dispatch(getDetailExcoPusat(safeTingkat, daerahId));
    }
  }, [dispatch, tingkatExcoId, daerahId, nameExco]);

  const renderValueDelete = (
    <div align="center">
      <HelpIcon style={{ fontSize: 60, color: "#F06524" }} />
      <h3>Perhatian!</h3>
      <p>
        Yakin Untuk Menghapus File <br /> <b>{docName}</b> ?
      </p>
      <Gap height={20} />
      <div align="center" style={{ display: "flex", justifyContent: "center" }}>
        <MyButton
          component="span"
          color="black"
          backgroundColor="white"
          backgroundColorHover="#F06524"
          variant="outlined"
          colorHover="white"
          children="Batal"
          borderColor="#F06524"
          onClick={handleCloseDialogDelete}
          style={{ width: "100%" }}
        />
        <Gap width={10} />
        <MyButton
          component="span"
          color="#FFFFFF"
          backgroundColor="#F06524"
          backgroundColorHover="#F06524"
          variant="outlined"
          colorHover="white"
          children="Hapus"
          borderColor="#F06524"
          style={{ width: "100%" }}
          onClick={() => handleDeleteFile(categoryDoc, idDocument)}
        />
      </div>
    </div>
  );

  const renderValueView = (
    <>
      <iframe
        title="pdfView"
        // src={"data:application/pdf;base64," + documentView}
        src={documentView}
        style={{ width: "100%", height: "80vh" }}
      ></iframe>
    </>
  );

  const renderEditSKPengurus = (
    <>
      <div align="center" style={{ fontSize: 22, fontWeight: 700 }}>
        <p>Ubah Informasi Kepengurusan</p>
      </div>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          formik.handleSubmit(e);
        }}
      >
        <MyInput
          id="nomer_sk_pengurus"
          name="nomer_sk_pengurus"
          label="Nomor SK Pengurus*"
          fullWidth
          size="medium"
          value={formik.values.nomer_sk_pengurus}
          onChange={formik.handleChange}
          error={
            formik.touched.nomer_sk_pengurus &&
            Boolean(formik.errors.nomer_sk_pengurus)
          }
          helperText={
            formik.touched.nomer_sk_pengurus && formik.errors.nomer_sk_pengurus
          }
        />
        <Gap height={10} />
        <div style={{ width: "100%" }}>
          <label
            style={{
              fontSize: 13,
              color: "#6b7280",
              marginBottom: 8,
              display: "block",
            }}
          >
            Tanggal SK Pengurus Pleno*
          </label>
          <DatePicker
            selected={
              formik.values.tanggal_sk
                ? new Date(formik.values.tanggal_sk)
                : null
            }
            onChange={(date) => {
              if (date) {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const day = String(date.getDate()).padStart(2, "0");
                const formattedDate = `${year}-${month}-${day}`;
                formik.setFieldValue("tanggal_sk", formattedDate);
              } else {
                formik.setFieldValue("tanggal_sk", "");
              }
            }}
            dateFormat="dd/MM/yyyy"
            placeholderText="dd/mm/yyyy"
            withPortal
            customInput={
              <input
                style={{
                  width: "100%",
                  height: 42,
                  padding: "0 12px",
                  borderRadius: 8,
                  border:
                    formik.touched.tanggal_sk && formik.errors.tanggal_sk
                      ? "1px solid #d32f2f"
                      : "1px solid #e5e7eb",
                  fontSize: 13,
                  outline: "none",
                  boxSizing: "border-box",
                }}
              />
            }
          />
          {formik.touched.tanggal_sk && formik.errors.tanggal_sk && (
            <p
              style={{
                color: "#d32f2f",
                fontSize: 12,
                marginTop: 4,
                marginLeft: 14,
              }}
            >
              {formik.errors.tanggal_sk}
            </p>
          )}
        </div>
        <Gap height={10} />
        <div style={{ display: "flex" }}>
          <MyButton
            height="40px"
            color="#B9B9B9"
            fullWidth
            backgroundColor="#FFFFFFFF"
            borderColor="#B9B9B9"
            backgroundColorHover="#FFFFFFFF"
            variant="outlined"
            children="Batal"
            onClick={handleCloseDialogSKPengurus}
          />
          <Gap width={30} />
          <MyButton
            height="40px"
            color="#8B8B8B"
            colorHover="white"
            fullWidth
            backgroundColor="#E8E8E8"
            borderColor="#E8E8E8"
            backgroundColorHover="#F06524"
            variant="outlined"
            children="Simpan"
            type="submit"
          />
        </div>
      </form>
    </>
  );

  const profile = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
  //cek hak akses
  const checkHakAkses = (list, akses) => {
    let has = false;
    list?.map((val) => {
      if (val.hak_akses === akses) {
        has = true;
      }
      if (val.hak_akses === "Super Admin Semata") {
        has = true;
      }
    });
    return has;
  };

  // handle history file
  const handleHistoryDokumen = async (param, id) => {
    setOpenHistory(true);
    const resp = await dispatch(listHistoryDocument(officeId, param));
    if (resp.type === "LIST_HISTORY_DOCUMENT_SUCCESS") {
      let data = await resp.payload.data;
      setDataHistoryDokumen(data);
    }
  };
  const handleDownloadHistoryDokumen = async (id) => {
    try {
      setLoadingHistoryDownloadId(id);
      const resp = await dispatch(downloadHistoryDocument(id));
      if (resp.type === "DOWNLOAD_HISTORY_DOCUMENT_SUCCESS") {
        let data = await resp.payload.dokumen;
        let a = document.createElement("a");
        a.href = data;
        a.download = resp.payload.file_name;
        a.click();
      } else {
        setMessage("Gagal mengunduh dokumen. Silakan coba lagi.");
        setOpenDialogAlert(true);
        setStatus("error");
      }
    } catch (err) {
      setMessage("Terjadi kesalahan saat mengunduh dokumen.");
      setOpenDialogAlert(true);
      setStatus("error");
    } finally {
      setLoadingHistoryDownloadId(null);
    }
  };
  const convertDate = (date) => {
    let months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "Mei",
      "Jun",
      "Jul",
      "Agu",
      "Sep",
      "Okt",
      "Nov",
      "Des",
    ];
    var local = new Date(date);
    return (
      local.getDate() +
      " " +
      months[local.getMonth()] +
      " " +
      local.getFullYear()
    );
  };

  const renderHistoryFile = (
    <div align="center">
      <h3>Riwayat Perubahan Dokumen</h3>
      <div style={{ width: "100%", overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th
                style={{
                  textAlign: "left",
                  padding: "4px",
                  borderBottom: "#96D4D4 solid 2px",
                }}
              >
                No.
              </th>
              <th
                style={{
                  textAlign: "left",
                  padding: "4px",
                  borderBottom: "#96D4D4 solid 2px",
                }}
              >
                Aksi Peubahan
              </th>
              <th
                style={{
                  textAlign: "left",
                  padding: "4px",
                  borderBottom: "#96D4D4 solid 2px",
                }}
              >
                Nama Dokumen
              </th>
              <th
                style={{
                  textAlign: "left",
                  padding: "4px",
                  borderBottom: "#96D4D4 solid 2px",
                }}
              >
                Waktu Perubahan
              </th>
              <th
                style={{
                  textAlign: "left",
                  padding: "4px",
                  borderBottom: "#96D4D4 solid 2px",
                }}
              >
                Oleh
              </th>
              <th
                style={{
                  textAlign: "left",
                  padding: "4px",
                  borderBottom: "#96D4D4 solid 2px",
                }}
              >
                Unduh
              </th>
            </tr>
          </thead>
          <tbody>
            {dataHistoryDokumen?.map((item, key) => {
              return (
                <tr key={key} style={{ borderBottom: "#96D4D4 solid 1px" }}>
                  <td style={{ textAlign: "left", padding: "4px" }}>
                    {key + 1}
                  </td>
                  <td style={{ textAlign: "left", padding: "4px" }}>
                    {item.action}
                  </td>
                  <td style={{ textAlign: "left", padding: "4px" }}>
                    <div style={{ wordWrap: "break-word" }}>
                      {item.new_value}
                    </div>
                  </td>
                  <td style={{ textAlign: "left", padding: "4px" }}>
                    {convertDate(item.created_date)}
                  </td>
                  <td style={{ textAlign: "left", padding: "4px" }}>
                    {item.pembuat?.nama}
                  </td>
                  <td style={{ textAlign: "left", padding: "4px" }}>
                    {item.action !== "DELETE" ? (
                      <button
                        onClick={() =>
                          handleDownloadHistoryDokumen(item.id_record)
                        }
                        disabled={loadingHistoryDownloadId === item.id_record}
                        style={{
                          cursor:
                            loadingHistoryDownloadId === item.id_record
                              ? "not-allowed"
                              : "pointer",
                          backgroundColor: "white",
                          margin: "6px",
                          padding: "6px 8px",
                          border: "2px rgb(240, 101, 36) solid",
                          color: "rgb(240, 101, 36)",
                          borderRadius: "6px",
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          opacity:
                            loadingHistoryDownloadId === item.id_record
                              ? 0.7
                              : 1,
                        }}
                      >
                        {loadingHistoryDownloadId === item.id_record ? (
                          <>
                            <CircularProgress
                              size={14}
                              style={{ color: "rgb(240, 101, 36)" }}
                            />
                            Mengunduh...
                          </>
                        ) : (
                          "Unduh Dokumen"
                        )}
                      </button>
                    ) : (
                      ""
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <Gap height={20} />
      <div align="center" style={{ display: "flex", justifyContent: "center" }}>
        <MyButton
          component="span"
          color="black"
          backgroundColor="white"
          backgroundColorHover="#F06524"
          variant="outlined"
          colorHover="white"
          children="Kembali"
          borderColor="#F06524"
          onClick={handleCloseDialogHistory}
          style={{ width: "100%" }}
        />
      </div>
    </div>
  );

  return (
    <>
      <MyDialog
        openDialog={openHistory}
        handleCloseDialog={handleCloseDialogHistory}
        renderValue={renderHistoryFile}
        fullWidth={true}
        maxWidth={"medium"}
      />

      {/* delete file */}
      <MyDialog
        openDialog={openDelete}
        handleCloseDialog={handleCloseDialogDelete}
        renderValue={renderValueDelete}
        // fullWidth={true}
        // maxWidth={"medium"}
      />
      {/* view file pdf */}
      <MyDialog
        openDialog={openView}
        handleCloseDialog={handleCloseDialogView}
        renderValue={renderValueView}
        fullWidth={true}
        maxWidth={"medium"}
      />
      {/* open dialog sk pengurus*/}
      <MyDialog
        openDialog={openDialogSKPengurus}
        handleCloseDialog={handleCloseDialogSKPengurus}
        renderValue={renderEditSKPengurus}
        fullWidth={true}
        maxWidth={"sm"}
      />
      {/* alertMessage */}
      <AlertMessage
        openDialog={openDialogAlert}
        message={message}
        status={status}
        handleCloseDialog={() => setOpenDialogAlert(false)}
      />

      {/* <p
        style={{
          fontSize: 24,
          color: "#757575",
          fontWeight: 700,
          marginBottom: "0px",
        }}
      >
        Dokumen Kepengurusan
      </p> */}
      <Gap height={20} />
      <Paper elevation={0} style={{ padding: 10 }}>
        <Grid container spacing={3} style={{ padding: 10 }}>
          <Grid item xs={12}>
            <div
              style={{
                border: "1px solid #ededed",
                borderRadius: 4,
                padding: "16px 20px",
              }}
            >
              {/* Header Row */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 16,
                }}
              >
                <p
                  style={{
                    color: "#212121",
                    fontWeight: 500,
                    fontSize: 15,
                    margin: 0,
                  }}
                >
                  Informasi Kepengurusan
                </p>
                <div>
                  {!isLocked &&
                  (checkHakAkses(
                    profile?.data?.hak_akses,
                    "Document Admin Access",
                  ) ||
                    checkHakAkses(
                      profile?.data?.hak_akses,
                      "Document Manager Access",
                    )) ? (
                    <MyButton
                      component="span"
                      color="#757575"
                      backgroundColor="#FFFFFF"
                      backgroundColorHover="#f5f5f5"
                      variant="outlined"
                      colorHover="#757575"
                      borderColor="#e0e0e0"
                      onClick={() => handleOpenSKPengurus()}
                    >
                      Ubah ✏️
                    </MyButton>
                  ) : null}
                </div>
              </div>

              {/* Data Rows */}
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                <div style={{ display: "flex" }}>
                  <p
                    style={{
                      color: "#212121",
                      fontWeight: 400,
                      fontSize: 14,
                      margin: 0,
                      minWidth: 180,
                    }}
                  >
                    No. SK Pengurus Pleno
                  </p>
                  <p
                    style={{
                      color: "#212121",
                      fontWeight: 400,
                      fontSize: 14,
                      margin: 0,
                    }}
                  >
                    : {dataDetail?.nomer_sk_pengurus || "-"}
                  </p>
                </div>
                <div style={{ display: "flex" }}>
                  <p
                    style={{
                      color: "#212121",
                      fontWeight: 400,
                      fontSize: 14,
                      margin: 0,
                      minWidth: 180,
                    }}
                  >
                    Tanggal SK Pengurus Pleno
                  </p>
                  <p
                    style={{
                      color: "#212121",
                      fontWeight: 400,
                      fontSize: 14,
                      margin: 0,
                    }}
                  >
                    :{" "}
                    {dataDetail?.tanggal_sk
                      ? convertDate(dataDetail.tanggal_sk)
                      : "dd/mm/yyyy"}
                  </p>
                </div>
              </div>
            </div>
          </Grid>
          {/* Unggah SK Pengurus* */}
          {resultArr?.map((item, key) => {
            // console.log({ resultArr });
            return (
              <Grid item xs={12} md={6} key={key}>
                <MyUploadFile
                  hasAccess={
                    !isLocked &&
                    (checkHakAkses(
                      profile?.data?.hak_akses,
                      "Document Admin Access",
                    ) ||
                      checkHakAkses(
                        profile?.data?.hak_akses,
                        "Document Manager Access",
                      ))
                      ? true
                      : false
                  }
                  loading={loading}
                  label={`Unggah Scan ${item?.kategori_dokumen?.nama}*`}
                  handleselectedFile={(e) =>
                    handleselectedFiles(e, item?.kategori_dokumen?.id)
                  }
                  fileName={
                    item?.kategori_dokumen?.id === 1
                      ? fileNamePengurus
                      : item?.kategori_dokumen?.id === 2
                        ? fileNameMenkumham
                        : item?.kategori_dokumen?.id === 9
                          ? fileNameMenkumhamAD
                          : item?.kategori_dokumen?.id === 7
                            ? fileNameAktaNotaris
                            : item?.kategori_dokumen?.id === 8
                              ? fileNameKeBangSol
                              : item?.kategori_dokumen?.id === 10
                                ? fileNameBadanHukum
                                : item?.kategori_dokumen?.id === 11
                                  ? fileNameAktaNotarisPendirian
                                  : item?.kategori_dokumen?.id === 12
                                    ? fileNameLambangPartai
                                    : item?.kategori_dokumen?.id === 13
                                      ? fileNameLambangPartaiMenkumham
                                      : item?.kategori_dokumen?.id === 14
                                        ? fileNamePernyataanModelF
                                        : item?.kategori_dokumen?.id === 16
                                          ? fileNameSKLampiran
                                          : null
                  }
                  handleDeleteFile={() => {
                    handleOpenDelete(
                      item?.kategori_dokumen?.id,
                      item?.id_dokumen,
                      item?.kategori_dokumen?.nama,
                    );
                  }}
                  handleDownloadFile={() => {
                    handleDownloadDoc(
                      item?.kategori_dokumen?.id,
                      item?.id_dokumen,
                    );
                  }}
                  handleView={() => {
                    handleViewDoc(item?.kategori_dokumen?.id, item?.id_dokumen);
                  }}
                  handleHistoryDokumen={() => {
                    handleHistoryDokumen(
                      item?.kategori_dokumen?.id,
                      item?.id_dokumen,
                    );
                  }}
                />
              </Grid>
            );
          })}
        </Grid>
      </Paper>
    </>
  );
};

export default DokumenKepengurusan;
